module.exports = __webpack_public_path__ + "static/media/flow.aba97c33.svg";